import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Chartist from 'chartist';

import TooltipPlugin from './TooltipPlugin';

const seriesColors = [
  '#009592',
  'rgba(255, 255, 255, 0.15)',
  '#009592'
];

const styles = options => line => {
  line.on('draw', data => {
    if (data.type === 'line') {
      data.element.attr({
        fill: 'none',
        stroke: seriesColors[data.seriesIndex],
        'stroke-width': '2px'
      });

      if (data.seriesIndex === 2) {
        data.element.attr({
          'stroke-dasharray': '2px'
        });
      }
    }

    if (data.type === 'point') {
      data.element.attr({
        fill: 'none',
        stroke: 'transparent',
        'stroke-width': '10px',
        'stroke-linecap': 'round'
      });
    }

    if (data.type === 'grid') {
      data.element.attr({
        'stroke-width': '1px',
        stroke: data.axis.units.dir === 'horizontal' ? '#4a4a4a' : 'rgba(3, 181, 177, 0.2)'
      });
    }

    if (data.type === 'label') {
      const { axisLength, counterUnits } = data.axis;

      if (counterUnits.dir === 'vertical' && data.x > axisLength - 25) {
        data.element.remove();
      }

      if (counterUnits.dir === 'horizontal') {
        const { ticks } = data.axis;
        const diff = Math.max(...ticks) - Math.min(...ticks);
        const step = Math.min(Math.round(diff / 2), 20);

        if (data.y < 20 || data.text % step !== 0) {
          data.element.remove();
        }
      }
    }
  });
};

class Chart extends PureComponent {
  componentDidMount() {
    this.buildChart();
  }

  componentDidUpdate() {
    this.buildChart();
  }

  parsePoint(point, field) {
    if (!point) {
      return null;
    }

    return {
      value: point[field],
      meta: point.date
    };
  }

  buildChart() {
    if (!this.chart) {
      return;
    }

    const labels = [];
    const uscProfit = [];
    const reference = [];
    const depositProfit = [];
    let max = 0;
    let min = 0;

    this.props.points.forEach(el => {
      labels.push(el.year);
      uscProfit.push(this.parsePoint(el.point, 'uscProfit'));
      reference.push(this.parsePoint(el.point, 'reference'));
      depositProfit.push(this.parsePoint(el.point, 'depositProfit'));

      if (el.point) {
        max = Math.max(max, el.point.uscProfit, el.point.reference, el.point.depositProfit);
        min = Math.min(min, el.point.uscProfit, el.point.reference, el.point.depositProfit);
      }
    });

    const data = {
      labels,
      series: [
        {
          name: 'usc',
          data: uscProfit
        },
        {
          name: 'reference',
          data: reference
        },
        {
          name: 'deposit',
          data: depositProfit
        }
      ]
    };

    const chartistOptions = {
      width: '100%',
      height: '100%',
      fullWidth: true,
      showPoint: true,
      showGrid: false,
      showGridBackground: false,
      chartPadding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
      axisY: {
        showGrid: true,
        showLabel: true,
        offset: 0,
        labelOffset: {
          x: 5,
          y: 0
        }
      },
      axisX: {
        showGrid: true,
        showLabel: true,
        offset: 0,
        position: 'start',
        labelOffset: {
          x: 5,
          y: -5
        },
        labelInterpolationFnc: (value, index, array) => {
          const prev = array[index - 1];
          return (!prev || prev !== value) ? value : null;
        }
      },

      classNames: {
        chart: 'chart-main',
        label: 'chart-label',
        labelGroup: 'chart-labels',
        series: 'chart-series',
        line: 'chart-line',
        point: 'chart-point',
        area: 'chart-area',
        grid: 'chart-grid',
        gridGroup: 'chart-grids',
        gridBackground: 'chart-grid-background',
        vertical: 'chart-vertical',
        horizontal: 'chart-horizontal',
        start: 'chart-start',
        end: 'chart-end'
      },
      plugins: [
        styles(),
        TooltipPlugin()
      ],
      lineSmooth: Chartist.Interpolation.simple({
        fillHoles: true
      })
    };

    Chartist.Line(this.chart, data, Object.assign({}, chartistOptions, {
      axisY: Object.assign({}, chartistOptions.axisY, {
        low: min * 1.1,
        high: max * 1.1,
        scaleMinSpace: Math.max(Math.floor(max * 0.2), 10)
      })
    }));
  }

  render() {
    return (
      <div className="chart-container">
        <div
          ref={el => this.chart = el}
          className="chart-holder"
        />
      </div>
    );
  }
}

Chart.propTypes = {
  points: PropTypes.array.isRequired
};

export default Chart;



// WEBPACK FOOTER //
// ./src/components/Chart/Chart.js